<template>
  <div class="material-page">
    <div class="material-page__left">
      <material-author
        :material="material"
        class="material-page__author"
      />

      <material-table-of-contents
        v-if="material.isBoldTitleText"
        :content="materialBody.content"
      />
    </div>

    <div class="material-page__content">
      <slot
        v-if="isOlympiad && olympiadRegister"
        name="olympiad"
        :close="() => olympiadRegister = false"
      />

      <material-tags
        :material="material"
      />

      <div class="material-page__header-desktop">
        <material-images
          :material="material"
          class="material-page__images"
        />

        <div class="material-page__header_content">
          <h1 class="material-page__title">
            {{ material.title }}
          </h1>
          <h5
            v-if="!(isWebinar || isOlympiad)"
            class="material-page__reading"
          >
            Время чтения {{ material.readingTime || 0 }} мин
          </h5>
          <webinar-register
            v-if="isWebinar"
            :webinar="material.publicWebinar || {}"
            :have-user="haveUser"
          />
          <olympiad-register
            v-if="isOlympiad && material.olympiadPack"
            :material="material"
            @openRegister="olympiadRegister = true"
          />

          <div
            v-if="!isOlympiad"
            class="material-page__statistic"
          >
            <material-statistic
              :material="material"
              views
            />
            <material-statistic
              :material="material"
              likes
            />
          </div>
        </div>
      </div>

      <div class="material-page__header-tablet">
        <div class="material-page__header_content">
          <h1 class="material-page__title">
            {{ material.title }}
          </h1>
          <h5
            v-if="!(isWebinar || isOlympiad)"
            class="material-page__reading"
          >
            Время чтения {{ material.readingTime || 0 }} мин
          </h5>

          <webinar-register
            :webinar="material.publicWebinar || {}"
            :have-user="haveUser"
          />
        </div>

        <div class="material-page__header_info">
          <olympiad-register
            v-if="isOlympiad && material.olympiadPack"
            :material="material"
            @openRegister="olympiadRegister = true"
          />

          <material-author
            :material="material"
            class="material-page__author"
          />

          <material-table-of-contents
            v-if="material.isBoldTitleText"
            :content="materialBody.content"
          />
        </div>

        <div class="material-page__header_right">
          <material-images
            :material="material"
            class="material-page__images"
          />

          <div
            v-if="!isOlympiad"
            class="material-page__statistic"
          >
            <material-statistic
              :material="material"
              views
            />
            <material-statistic
              :material="material"
              likes
            />

            <material-share-mobile tablet>
              <slot name="share" />
            </material-share-mobile>
          </div>
        </div>
      </div>

      <div class="material-page__header-mobile">
        <h1 class="material-page__title">
          {{ material.title }}
        </h1>

        <olympiad-register
          v-if="isOlympiad && material.olympiadPack"
          :material="material"
          @openRegister="olympiadRegister = true"
        />

        <webinar-register
          :webinar="material.publicWebinar || {}"
          :have-user="haveUser"
        />

        <div class="material-page__header_info">
          <material-author
            :material="material"
            class="material-page__author"
          />

          <div class="material-page__header_data-time">
            <p>{{ materialDate }}</p>
            <h5
              v-if="!(isWebinar || isOlympiad)"
              class="material-page__reading"
            >
              Время чтения {{ material.readingTime || 0 }} мин
            </h5>
          </div>
        </div>

        <div class="material-page__header_right">
          <material-images
            :material="material"
            class="material-page__images"
          />

          <div
            v-if="!isOlympiad"
            class="material-page__statistic"
          >
            <material-statistic
              :material="material"
              views
            />
            <material-statistic
              :material="material"
              likes
            />

            <material-share-mobile>
              <slot name="share" />
            </material-share-mobile>
          </div>
        </div>

        <material-table-of-contents
          v-if="material.isBoldTitleText"
          :content="materialBody.content"
        />
      </div>

      <div class="material-page__header-banner">
        <material-banner
          v-for="banner in bannerByCategories.headerBanners"
          :key="`footer-banner-${banner.id}`"
          :banner="banner"
        />
      </div>

      <div class="material-page__body">
        <h5
          v-if="webinarDate"
          class="material-page__body--webinar-date"
        >
          Дата и время проведения: {{ webinarDate }}
        </h5>

        <p v-if="material.previewText">
          {{ material.previewText }}
        </p>
      </div>

      <div class="material-page__body">
        <webinar-widget
          :webinar-data="material.publicWebinar"
          :user-register-on-webinar="userRegisterOnWebinar"
          @signUpToWebinar="$emit('signUpToWebinar')"
          @chooseCourse="$emit('chooseCourse')"
        />
      </div>

      <div
        v-for="(content, index) in materialBody.content"
        :key="index"
        class="material-page__body"
      >
        <audio-player
          v-if="content.type === BLOCK_TYPES.AUDIO"
          :value="content.payload.url"
        />
        <video-player
          v-else-if="content.type === BLOCK_TYPES.VIDEO"
          :value="content.payload.url"
        />
        <p v-else-if="content.type === BLOCK_TYPES.TEXT">
          {{ content.payload }}
        </p>
        <div
          v-else-if="content.type === BLOCK_TYPES.HTML"
          v-html="content.payload"
        />
        <material-banner
          v-else-if="content.type === BLOCK_TYPES.BANNER"
          :banner="getBannerById(content.payload)"
        />

        <preview-widgets
          v-if="content.type === BLOCK_TYPES.WIDGET"
          :payload="content.payload"
          :get-materials-func="getMaterialsFunc"
        />
      </div>

      <olympiad-prizes
        v-if="isOlympiad && material.olympiad && material.olympiad.olympiadPrizePositions.length"
        :prizes="material.olympiad.olympiadPrizePositions"
      />

      <div
        v-if="materialBody.files.length"
        class="material-page__files"
      >
        <span>Прикрепленные файлы:</span>
        <a
          v-for="(content, index) in materialBody.files"
          :key="index"
          :href="content.payload.url"
          download
          target="_blank"
          :title="content.payload.name"
        >
          {{ content.payload.name }}
        </a>
      </div>

      <div class="material-page__footer-banner">
        <material-banner
          v-for="banner in bannerByCategories.footerBanners"
          :key="`footer-banner-${banner.id}`"
          :banner="banner"
        />
      </div>

      <slot name="bottom" />
    </div>

    <div class="material-page__right">
      <slot name="share" />
      <slot name="banner" />
    </div>
  </div>
</template>

<script>
import PreviewWidgets from './components/PreviewWidgets.vue';
import MaterialTableOfContents from './components/MaterialTableOfContents.vue';
import WebinarWidget from './components/WebinarWidget.vue';
import MaterialTags from './components/MaterialTags.vue';
import MaterialImages from './components/MaterialImages.vue';
import MaterialAuthor from './components/MaterialAuthor.vue';
import WebinarRegister from './components/WebinarRegister.vue';
import MaterialShareMobile from './components/MaterialShareMobile.vue';
import MaterialStatistic from './components/MaterialStatistic.vue';

import MaterialBanner from '../MaterialBanner/index.vue';
import AudioPlayer from '../../components/AudioPlayer.vue';
import VideoPlayer from '../../components/VideoPlayer.vue';

import { BLOCK_TYPES } from './constants';
import OlympiadRegister from './components/OlympiadRegister.vue';
import OlympiadPrizes from './components/OlympiadPrizes.vue';

export default {
  name: 'SchoolMaterialViewer',
  components: {
    OlympiadPrizes,
    OlympiadRegister,
    MaterialStatistic,
    MaterialShareMobile,
    WebinarRegister,
    MaterialAuthor,
    MaterialImages,
    MaterialTags,
    MaterialBanner,
    MaterialTableOfContents,
    PreviewWidgets,
    VideoPlayer,
    AudioPlayer,
    WebinarWidget,
  },
  props: {
    material: { type: Object, required: true },
    getMaterialsFunc: { type: Function, required: true },
    materialsBanners: { type: Array, required: true },
    userRegisterOnWebinar: { type: [Object, Boolean], default: null },
    haveUser: { type: Boolean, default: false },
  },

  data: () => ({
    olympiadRegister: false,
    BLOCK_TYPES,
  }),

  computed: {
    isWebinar() {
      return Boolean(this.material?.publicWebinar?.id);
    },
    webinarDate() {
      if (this.isWebinar) {
        const date = new Date(this.material.publicWebinar.startDate);

        const options = {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          timeZone: 'Europe/Moscow',
        };

        return `${date.toLocaleString('ru-RU', options)}  (мск)`;
      }
      return null;
    },
    isOlympiad() {
      return this.material?.categories?.some((category) => category.slug === 'olympiad');
    },

    materialBody() {
      const content = [];
      const files = [];

      if (this.material.body) {
        this.material.body.forEach((item) => {
          if (item.type === BLOCK_TYPES.FILE) {
            files.push(item);
          } else {
            content.push(item);
          }
        });
      }

      return { content, files };
    },
    bannerByCategories() {
      const headerBanners = [];
      const footerBanners = [];

      if (!this.material.categories) {
        return { headerBanners, footerBanners };
      }

      const materialCategoriesIds = this.material.categories.map((category) => {
        if (category?.id) return Number(category.id);
        return category;
      });

      this.materialsBanners
        .filter((banner) => {
          if (banner.general) return true;

          const bannerCategoriesIds = banner.categories.map(({ id }) => Number(id));

          return banner.categories.some((category) => {
            const categoryIncludes = materialCategoriesIds.includes(Number(category.id));
            const haveSubCategoryInBannerCategory = category?.children?.some(({ id }) => (
              bannerCategoriesIds.includes(Number(id))
            ));

            return categoryIncludes && !haveSubCategoryInBannerCategory;
          });
        })
        .forEach((banner) => {
          if (banner.header) headerBanners.push(banner);
          if (banner.footer) footerBanners.push(banner);
        });

      return { headerBanners, footerBanners };
    },

    // materialImages() {
    //   if (this.material.covers?.length) {
    //     return this.material.covers.map(({ url }) => url);
    //   }
    //
    //   const materialCategory = this.material.categories?.[0] || { slug: 'articles', name: 'Статьи' };
    //   return [getCategoryImageUrl(materialCategory)];
    // },
    materialDate() {
      return new Date(this.material?.createdAt).toLocaleDateString('ru-RU');
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    'material.id': function () {
      this.$nextTick(() => {
        document.querySelectorAll('.material-page__body').forEach((body) => {
          body.querySelectorAll('a').forEach((link) => {
            link.setAttribute('target', '_blank');
          });
        });
      });
    },
  },

  mounted() {
    // чтобы работал sticky
    if (document.querySelector('.v2-layout')) {
      document.querySelector('.v2-layout').style.overflow = 'inherit';
    }
  },
  methods: {
    getBannerById(bannerId) {
      return (this.materialsBanners || []).find(({ id }) => Number(id) === Number(bannerId)) || {};
    },

    updateTime() {
      this.now = new Date();
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../styles/main.scss';

.material-page {
  position: relative;
  width: 100%;
  display: flex;
  margin-inline: auto;

  @include media-down($size-tablet) {
    flex-direction: column;
    gap: calc(var(--scale) * 24);
  }

  ::v-deep(*) {
    font-family: 'Onest', sans-serif;
  }

  // left
  &__left {
    max-width: calc(var(--scale) * 355);
    margin-right: calc(var(--scale) * 110);
    position: sticky;
    top: calc(var(--scale) * 130);
    height: fit-content;

    @include media-down($size-tablet) {
      display: none;
    }
  }

  &__author {
    margin-bottom: calc(var(--scale) * 24);

    @include media-down($size-mobile) {
      margin-bottom: 0;
    }
  }

  // center
  &__content {
    max-width: calc(var(--scale) * 890);
    width: 100%;
  }

  .material-tags {
    margin-bottom: calc(var(--scale) * 20);

    @include media-down($size-tablet) {
      margin-bottom: calc(var(--scale) * 12);
    }

    @include media-down($size-mobile) {
      :deep(p) {
        display: none;
      }
    }
  }

  &__header-desktop {
    display: flex;
    gap: calc(var(--scale) * 20);
    margin-bottom: calc(var(--scale) * 38);

    @include media-down($size-tablet) {
      display: none;
    }
  }

  &__header-tablet {
    @include media-up($size-tablet) {
      display: none;
    }

    @include media-down($size-mobile) {
      display: none;
    }

    display: flex;
    flex-wrap: wrap;
    gap: calc(var(--scale) * 24) calc(var(--scale) * 17);
    margin-bottom: calc(var(--scale) * 40);

    .material-page__header_content {
      width: 100%;
    }

    .material-page__header_info {
      width: calc(var(--scale) * 355);
    }
  }

  &__header-mobile {
    @include media-up($size-mobile) {
      display: none;
    }

    margin-bottom: calc(var(--scale) * 32);

    .material-page__header_info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: calc(var(--scale) * 10);

      .material-page__header_data-time p {
        margin-bottom: calc(var(--scale) * 3);
        font-weight: 500;
        font-size: calc(var(--scale) * 12);
        line-height: 130%;
        text-align: right;
        color: #A7ABAC;
      }
    }
  }

  .material-page__header_content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-bottom: calc(var(--scale) * 20);
    flex-grow: 1;

    @include media-down($size-tablet) {
      padding-bottom: 0;
    }
  }

  .material-page__title {
    padding-left: calc(var(--scale) * 8);
    margin-top: calc(var(--scale) * 6);
    margin-bottom: calc(var(--scale) * 10);

    font-weight: 700;
    font-size: calc(var(--scale) * 32);
    line-height: 120%;
    color: #02120F;

    @include media-down($size-tablet) {
      padding-left: 0;
      margin-top: 0;
    }

    @include media-down($size-mobile) {
      margin-bottom: calc(var(--scale) * 32);
    }
  }

  .material-page__register {
    padding-left: calc(var(--scale) * 8);

    @include media-down($size-tablet) {
      padding-left: 0;
    }
  }

  .material-page__reading {
    padding-left: calc(var(--scale) * 8);
    font-weight: 500;
    font-size: calc(var(--scale) * 16);
    line-height: 130%;
    color: #A7ABAC;

    @include media-down($size-tablet) {
      padding-left: 0;
      font-size: calc(var(--scale) * 12);
    }
  }

  .material-page__statistic {
    margin-top: auto;
    display: flex;
    align-items: center;
    gap: calc(var(--scale) * 12);

    @include media-down($size-tablet) {
      height: calc(var(--scale) * 39);
    }
  }

  .material-page__images {
    padding-bottom: calc(var(--scale) * 20);
    flex-shrink: 0;
    max-width: calc(var(--scale) * 400);

    @include media-down($size-tablet) {
      max-width: calc(var(--scale) * 364);
      padding-bottom: 0;
    }

    @include media-down($size-mobile) {
      max-width: 100%;
    }
  }

  &__body {
    margin-bottom: calc(var(--scale) * 24);

    font-weight: 400;
    font-size: calc(var(--scale) * 16);
    line-height: 150%;
    color: #02120F;

    &--webinar-date {
      margin-bottom: calc(var(--scale) * 24);

      font-size: calc(var(--scale) * 24);
      font-weight: 600;
      line-height: 150%;
      text-align: left;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
      color: #02120F;
    }

    :deep(video) {
      padding: 0;
    }

    :deep(.player-container) {
      margin: 0;
    }

    :deep(a) {
      position: relative;
      overflow: hidden;
      color: $orange-color;
      text-decoration: none;
      white-space: nowrap;

      &:hover::after {
        width: 0;
        left: 100%;
      }

      &:after {
        content: '';
        height: 1px;
        width: 100%;
        position: absolute;
        left: 0;
        bottom: 0;
        background-color: $orange-color;
        transition: 300ms;
      }
    }

    :deep(figure) {
      width: 100% !important;
    }

    :deep(p strong) {
      font-weight: bold;
    }

    :deep(img) {
      border-radius: calc(var(--scale) * 24);
      width: 100% !important;
      height: auto;
      margin-bottom: calc(var(--scale) * 24);
    }

    :deep(ul) {
      list-style: initial;
      margin: auto 1em calc(var(--scale) * 24);
      padding-left: 1em;
    }

    :deep(ol) {
      list-style: auto;
      margin: auto 1em calc(var(--scale) * 24);
      padding-left: 1em;
    }

    :deep(h2) {
      font-size: calc(var(--scale) * 24);
      font-weight: bold;
      margin-bottom: calc(var(--scale) * 24);
    }

    :deep(h3) {
      font-size: 1.17em;
      font-weight: bold;
      margin-bottom: calc(var(--scale) * 24);
    }

    :deep(p) {
      margin-bottom: calc(var(--scale) * 24);

      font-weight: 400;
      font-size: calc(var(--scale) * 16);
      line-height: 150%;

      &:empty {
        display: none;
      }
    }

    :deep(li) {
      font-weight: 400;
      font-size: calc(var(--scale) * 16);
      line-height: 150%;
    }

    :deep(h4) {
      font-weight: bold;
    }

    :deep(blockquote) {
      max-width: calc(var(--scale) * 726);
      background-color: $white-color;
      border-radius: 2rem;
      margin-top: 1.5rem;
      margin-bottom: 1.5rem;
      padding: 3rem 6rem;
      position: relative;

      &::before,
      &::after {
        content: '';
        position: absolute;
        width: 3rem;
        height: 3rem;
        background-repeat: no-repeat;
        background-image: url('../../assets/images/blockquote.svg');
        opacity: 0.32;
      }

      &::before {
        left: 1.5rem;
        top: 1.5rem;
      }

      &::after {
        right: 1.5rem;
        bottom: 1.5rem;
        transform: rotate(180deg) scale(-1, 1);
      }

      p {
        margin-bottom: 0;
        font-style: italic;
        font-weight: 500;
        font-size: 1rem;
        line-height: 2rem;
        color: $grey;
      }
    }
  }

  &__files {
    margin-bottom: calc(var(--scale) * 24);

    span {
      color: $black-color;
      font-size: calc(var(--scale) * 16);
      line-height: 2;
    }

    a {
      max-width: 100%;
      display: block;
      width: fit-content;
      margin-top: calc(var(--scale) * 12);
      color: $orange-color;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      text-decoration: underline;
    }
  }

  &__header-banner {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 1rem;
  }

  &__footer-banner {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-top: 1rem;
  }

  .material-banner {
    border-radius: calc(var(--scale) * 20);
    overflow: hidden;
  }

  &__right {
    margin-left: auto;

    .material-share {
      top: calc(var(--scale) * 130);

      @include media-down($size-tablet) {
        display: none;
      }
    }

    .materials-item-proftest {
      position: sticky;
      top: calc(var(--scale) * 140);
      margin-top: calc(var(--scale) * 20);

      @include media-down($size-tablet) {
        position: relative;
        top: 0;
        height: calc(var(--scale) * 574);
        margin-top: 0;
      }
    }
  }
}

</style>
